"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CurrentSQON = void 0;

var _react = _interopRequireDefault(require("react"));

var _recompose = require("recompose");

var _reactComponentComponent = _interopRequireDefault(require("react-component-component"));

var _lodash = require("lodash");

var _dateFns = require("date-fns");

var _SQONView = _interopRequireWildcard(require("../SQONView"));

var _api = require("../utils/api");

var _translateSQONValue = _interopRequireDefault(require("../utils/translateSQONValue"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CurrentSQON = function CurrentSQON(_ref) {
  var _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? 'yyyy-MM-dd' : _ref$dateFormat,
      emptyMessage = _ref.emptyMessage,
      sqon = _ref.sqon,
      setSQON = _ref.setSQON,
      extendedMapping = _ref.extendedMapping,
      _ref$valueCharacterLi = _ref.valueCharacterLimit,
      valueCharacterLimit = _ref$valueCharacterLi === void 0 ? 30 : _ref$valueCharacterLi,
      _ref$onClear = _ref.onClear,
      onClear = _ref$onClear === void 0 ? function () {} : _ref$onClear,
      _ref$translateSQONVal = _ref.translateSQONValue,
      translateSQONValue = _ref$translateSQONVal === void 0 ? function (x) {
    return x;
  } : _ref$translateSQONVal,
      _ref$findExtendedMapp = _ref.findExtendedMappingField,
      findExtendedMappingField = _ref$findExtendedMapp === void 0 ? function (field) {
    return extendedMapping === null || extendedMapping === void 0 ? void 0 : extendedMapping.find(function (e) {
      return e.field === field;
    });
  } : _ref$findExtendedMapp,
      props = _objectWithoutProperties(_ref, ["dateFormat", "emptyMessage", "sqon", "setSQON", "extendedMapping", "valueCharacterLimit", "onClear", "translateSQONValue", "findExtendedMappingField"]);

  return /*#__PURE__*/_react["default"].createElement(_SQONView["default"], {
    emptyMessage: emptyMessage,
    sqon: sqon,
    FieldCrumb: function FieldCrumb(_ref2) {
      var _findExtendedMappingF;

      var field = _ref2.field,
          nextSQON = _ref2.nextSQON,
          props = _objectWithoutProperties(_ref2, ["field", "nextSQON"]);

      return /*#__PURE__*/_react["default"].createElement(_SQONView.Field, _objectSpread({
        field: field
      }, props), ((_findExtendedMappingF = findExtendedMappingField(field)) === null || _findExtendedMappingF === void 0 ? void 0 : _findExtendedMappingF.displayName) || field);
    },
    ValueCrumb: function ValueCrumb(_ref3) {
      var _findExtendedMappingF2, _findExtendedMappingF3;

      var field = _ref3.field,
          value = _ref3.value,
          nextSQON = _ref3.nextSQON,
          props = _objectWithoutProperties(_ref3, ["field", "value", "nextSQON"]);

      return /*#__PURE__*/_react["default"].createElement(_SQONView.Value, _extends({
        onClick: function onClick() {
          return setSQON(nextSQON);
        }
      }, props), (0, _lodash.truncate)((0, _recompose.compose)(translateSQONValue, _translateSQONValue["default"])(((_findExtendedMappingF2 = findExtendedMappingField(field)) === null || _findExtendedMappingF2 === void 0 ? void 0 : _findExtendedMappingF2.type) === 'date' && (0, _dateFns.format)(value, dateFormat) || (((_findExtendedMappingF3 = findExtendedMappingField(field)) === null || _findExtendedMappingF3 === void 0 ? void 0 : _findExtendedMappingF3.displayValues) || {})[value] || value), {
        length: valueCharacterLimit || Infinity
      }));
    },
    Clear: function Clear(_ref4) {
      var nextSQON = _ref4.nextSQON;
      return /*#__PURE__*/_react["default"].createElement(_SQONView.Bubble, {
        className: "sqon-clear",
        onClick: function onClick() {
          onClear();
          setSQON(nextSQON);
        }
      }, "Clear");
    }
  });
};

exports.CurrentSQON = CurrentSQON;

var CurrentSQONState = function CurrentSQONState(_ref5) {
  var sqon = _ref5.sqon,
      setSQON = _ref5.setSQON,
      graphqlField = _ref5.graphqlField,
      projectId = _ref5.projectId,
      props = _objectWithoutProperties(_ref5, ["sqon", "setSQON", "graphqlField", "projectId"]);

  return /*#__PURE__*/_react["default"].createElement(_reactComponentComponent["default"], {
    initialState: {
      extendedMapping: null
    },
    didMount: function didMount(_ref6) {
      var extendedMapping = _ref6.state.extendedMapping,
          setState = _ref6.setState;
      return (0, _api.fetchExtendedMapping)({
        graphqlField: graphqlField,
        projectId: projectId,
        api: props.api
      }).then(function (_ref7) {
        var extendedMapping = _ref7.extendedMapping;
        return setState({
          extendedMapping: extendedMapping
        });
      });
    }
  }, function (_ref8) {
    var extendedMapping = _ref8.state.extendedMapping;
    return /*#__PURE__*/_react["default"].createElement(CurrentSQON, _objectSpread({
      sqon: sqon,
      setSQON: setSQON,
      extendedMapping: extendedMapping
    }, props));
  });
};

var _default = CurrentSQONState;
exports["default"] = _default;